import React from 'react';

function CalendarIcon(props: object) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1875 0.5625V1.40625V2.25H11.8125V1.40625V0.5625H13.5V1.40625V2.25H15.75H17.4375V3.9375V15.1875C17.4375 16.7408 16.1783 18 14.625 18H3.375C1.8217 18 0.5625 16.7408 0.5625 15.1875V3.9375V2.25H2.25H4.5V1.40625V0.5625H6.1875ZM2.25 3.9375H15.75V6.75H2.25V3.9375ZM2.25 8.4375V15.1875C2.25 15.8088 2.75368 16.3125 3.375 16.3125H14.625C15.2463 16.3125 15.75 15.8088 15.75 15.1875V8.4375H2.25Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CalendarIcon;
